import { render, staticRenderFns } from "./SensorHistory.vue?vue&type=template&id=0ecfc6b0&scoped=true"
import script from "./SensorHistory.vue?vue&type=script&lang=js"
export * from "./SensorHistory.vue?vue&type=script&lang=js"
import style0 from "./SensorHistory.vue?vue&type=style&index=0&id=0ecfc6b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecfc6b0",
  null
  
)

export default component.exports